export const TRANSPORT_ORDERS_PATH = 'transport-orders';
export const TRANSPORT_ORDERS_BULK_PATH = 'transport-orders-bulk';
export const TRANSPORT_ORDERS_FEED_PATH = 'transport-orders-feed';
export const TRANSPORT_ORDER_FILES_PATH = (transportOrderId: string) => `transport-orders/${transportOrderId}/files`;

export const CONTRACTORS_PATH = 'contractors';